// components/CustomSelect.js
import React, { useState, useRef, useEffect } from "react";
import { FiChevronDown } from "react-icons/fi";

export default function CustomSelect({ name, value, onChange, options, error, touched }) {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (val) => {
        onChange(name, val);
        setIsOpen(false);
    };

    const selectedOption = options.find((opt) => opt.value === value);
    const selectedLabel = selectedOption?.label || "Select";
    const selectedColor = selectedOption?.color;

    return (
        <div className="relative" ref={ref}>
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className={`w-full text-left border p-3 rounded-lg flex justify-between items-center ${touched && error ? "border-red-500" : "border-gray-300"
                    }`}
            >
                <div className="flex items-center">
                    {selectedColor && (
                        <div 
                            className="w-3 h-3 rounded-full mr-2 flex-shrink-0"
                            style={{ backgroundColor: selectedColor }}
                        ></div>
                    )}
                    <span className={`${!value ? "text-gray-400" : ""}`}>{selectedLabel}</span>
                </div>
                <FiChevronDown className="ml-2 text-gray-500" />
            </button>

            {isOpen && (
                <div className="absolute mt-2 w-full max-h-[250px] h-fit overflow-auto bg-white shadow-lg border rounded-lg z-10">
                    {options.map((opt) => (
                        <div
                            key={opt.value}
                            onClick={() => handleSelect(opt.value)}
                            className={`px-4 py-2 cursor-pointer hover:bg-gray-100 flex items-center ${value === opt.value ? "bg-gray-100 font-medium" : ""
                                }`}
                        >
                            {opt.color && (
                                <div 
                                    className="w-3 h-3 rounded-full mr-2 flex-shrink-0"
                                    style={{ backgroundColor: opt.color }}
                                ></div>
                            )}
                            {opt.label}
                        </div>
                    ))}
                </div>
            )}
            {touched && error && <div className="text-red-500 text-xs mt-1">{error}</div>}
        </div>
    );
}
